import GlobalFooter from './GlobalFooter.vue'
export default GlobalFooter
